import { Button, Group } from '@mantine/core'

export const SubmitButton = ({ label }: { label: string }) => (
  <Group justify="center">
    <Button type="submit">{label}</Button>
  </Group>
)
